export const STORE_PROJECT_CONNECTIONS_DEFINITIONS = 'projectConnectionsDefinitionsUI';
export type STORE_PROJECT_CONNECTIONS_DEFINITIONS = typeof STORE_PROJECT_CONNECTIONS_DEFINITIONS;
